import React, { useEffect, useState } from "react";
import { getTaxes, deleteTax } from "../../api/TaxService";
import { FaEye, FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { getErrorMessage } from "../../utils/errorHandler";
import { useNavigate } from "react-router-dom";
import ActionIconButton from "../Shared/ActionIconButton";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";
export default function TaxList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getTaxes();
      setList(res?.data || res || []);
    } catch (err) {
      setError("Failed to load tax list");
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Delete this tax?")) return;
      await deleteTax(id);
      setSuccess("Tax deleted successfully");
      loadData();
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to delete tax");
      alert(getErrorMessage(error));
      setTimeout(() => setError(""), 3000);
    }
  };
  if (loading) {
    return <FullPageLoader text="Loading Taxes..." />;
  }
  return (
    <div className="container-fluid p-4 np-tax-page">
      {/* SUCCESS / ERROR */}
      {success && <div className="alert alert-success">{success}</div>}
      {/* HEADER */}
      <div className="card p-3 shadow-sm">
        {list.length === 0 ? (
          <EmptyState
            action={
              <button className="btn btn-primary" onClick={() => navigate("/tax/add")}>
                <FaPlus /> Add Tax
              </button>
            }
          />
        ) : (
          <>
        <div className="d-flex justify-content-end align-items-center pb-3">
          <button className="btn btn-primary" onClick={() => navigate("/tax/add")}>
            <FaPlus /> Add Tax
          </button>
        </div>
        {/* CARD */}

        <table className="table table-bordered table-hover bg-white">
          <thead style={{ background: "#f5f5f5" }}>
            <tr>
              <th className="text-dark fw-bold">#</th>
              <th className="text-dark fw-bold">Tax Name</th>
              <th className="text-dark fw-bold">CGST (%)</th>
              <th className="text-dark fw-bold">SGST (%)</th>
              <th className="text-dark fw-bold">IGST (%)</th>
              <th className="text-dark fw-bold">Total (%)</th>
              <th className="text-dark fw-bold">ACTION</th>
            </tr>
          </thead>
          <tbody>
            {list.map((tax, index) => (
              <tr key={tax._id}>
                <td>{index + 1}</td>
                <td>{tax.taxName}</td>
                <td>{tax.cgstPercentage}</td>
                <td>{tax.sgstPercentage}</td>
                <td>{tax.igstPercentage}</td>
                <td>
                  {(tax.cgstPercentage || 0) +
                    (tax.sgstPercentage || 0) +
                    (tax.igstPercentage || 0)}
                </td>
                <td className="text-center">
                  <div className="d-flex justify-content-center">
                    <ActionIconButton
                      icon={<FaEye />}
                      label="View"
                      variant="view"
                      onClick={() =>
                        navigate(`/tax/view/${tax.taxName}`, {
                          state: { taxId: tax._id },
                        })
                      }
                    />
                    <ActionIconButton
                      icon={<FaEdit />}
                      label="Edit"
                      variant="edit"
                      onClick={() =>
                        navigate("/tax/edit", {
                          state: { taxId: tax._id },
                        })
                      }
                    />

                    {/* DELETE */}
                    <ActionIconButton
                      icon={<FaTrash />}
                      label="Delete"
                      variant="delete"
                      onClick={() => handleDelete(tax._id)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
          </>
        )}
      </div>
    </div>
  );
}
